import { createSelector } from '@reduxjs/toolkit';
import { RootSelector, getStore } from '../../reducers';
import { Project } from '../../api';
import { isDemoSpaceName } from './model';

// NB: built only on top of `getStore`. Do NOT import app/project/category selectors
// here: project/selectors depends on this file, and app/selectors already imports
// project/selectors, so any of them would create an import cycle (madge -c).

const getDemoApp = createSelector(getStore, (s) => s.app);
const getDemoProjectsRaw = createSelector(getStore, (s) => s.project.projects);

// Per-instance gate (Settings.demo_welcome_mode_enabled). Absent -> false.
export const getDemoWelcomeModeEnabled: RootSelector<boolean> = createSelector(
  getDemoApp,
  (app) => app.settings?.demo_welcome_mode_enabled === true,
);

export const getSettingsLoaded: RootSelector<boolean> = createSelector(
  getDemoApp,
  (app) => app.settings !== undefined,
);

// Temporary heuristic until backend MYUA-17009 exposes `is_own` on Project:
// the user's own Space is the only project named "Your space".
export const getOwnSpaceId: RootSelector<Project['id'] | null> = createSelector(
  [getDemoWelcomeModeEnabled, getDemoApp, getDemoProjectsRaw],
  (enabled, app, projects) => {
    if (!enabled) return null;
    // A superuser sees other users' "Your space" projects with the same name.
    if (app.user?.is_superuser) return null;
    const matches = projects.filter((p) => isDemoSpaceName(p.name));
    return matches.length === 1 ? matches[0].id : null;
  },
);
